import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faPhone,
  faChevronDown,
  faPhoneAlt,
  faTimes,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchBarIsOpen, setSearchBarIsOpen] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({
    company: false,
    gallery: false
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1550);
  const [ModelIsOpen, setModelIsOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [phone, setPhone] = useState('');

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1550;
      setIsMobile(mobile);
      if (!mobile) {
        // Close all dropdowns when switching to desktop
        setDropdownStates({
          company: false,
          gallery: false
        });
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Close all dropdowns when toggling menu
    setDropdownStates({
      company: false,
      gallery: false
    });
  };

  const toggleSearchBar = () => {
    setSearchBarIsOpen(!searchBarIsOpen);
  };

  const toggleModel = () => {
    setModelIsOpen(!ModelIsOpen);
  };

  const toggleDropdown = (dropdownName) => {
    if (isMobile) {
      setDropdownStates(prev => ({
        ...prev,
        [dropdownName]: !prev[dropdownName]
      }));
    }
  };

  const handleDesktopHover = (dropdownName, isHovering) => {
    if (!isMobile) {
      setDropdownStates(prev => ({
        ...prev,
        [dropdownName]: isHovering
      }));
    }
  };

  const handleModalSubmit = () => {
    if (phone.trim() !== '') {
      setShowSuccess(true);
      setTimeout(() => {
        setModelIsOpen(false);
        setPhone('');
        setShowSuccess(false);
      }, 2500);
    }
  };

  return (
    <>
      <div className="navbar-container">
        <header className="navbar">
          <div className="nav-col1">
            <div className="nav-logo">
              <Link to="/">
                <img
                  src="https://callistusblinds.ae/wp-content/themes/MyCallistus/images/logo.svg"
                  alt="Marvel Logo"
                  className="navbar-logo"
                />
              </Link>
            </div>
            <div className="mobile-sec2">
              <div className="mobile-searchbar">
                <div className="nav-search-bar" onClick={toggleSearchBar}>
                  <FontAwesomeIcon icon={faSearch} />
                </div>
              </div>
              <div
                className={`navbar-toggle ${isMenuOpen ? 'open-toggle' : ''}`}
                onClick={toggleMenu}
              >
                <span className="toggle-L1"></span>
                <span className="toggle-L2"></span>
                <span className="toggle-L3"></span>
              </div>
            </div>
          </div>

          <div className="nav-col2">
            <ul className={`nav-links ${isMenuOpen ? 'open-nav-links' : ''}`}>
              <li
                className={`company-link ${isMobile ? 'mobile' : 'desktop'} ${dropdownStates.company ? 'open' : ''}`}
                onClick={() => toggleDropdown('company')}
                onMouseEnter={() => handleDesktopHover('company', true)}
                onMouseLeave={() => handleDesktopHover('company', false)}
              >
                <Link to="#">
                  Company
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`dropdown-arrow ${dropdownStates.company ? 'rotate' : ''}`}
                  />
                </Link>
                <ul className={`dropdown ${dropdownStates.company ? 'open' : ''}`}>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/WhyCallistus">Why Callistus</Link>
                  </li>
                  <li>
                    <Link to="/presence">Presence</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/products">Products</Link>
              </li>
              <li>
                <Link to="/special-solutions">Special Solutions</Link>
              </li>
              <li
                className={`gallery-link ${isMobile ? 'mobile' : 'desktop'} ${dropdownStates.gallery ? 'open' : ''}`}
                onClick={() => toggleDropdown('gallery')}
                onMouseEnter={() => handleDesktopHover('gallery', true)}
                onMouseLeave={() => handleDesktopHover('gallery', false)}
              >
                <Link to="#">
                  Gallery
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`dropdown-arrow ${dropdownStates.gallery ? 'rotate' : ''}`}
                  />
                </Link>
                <ul className={`dropdown ${dropdownStates.gallery ? 'open' : ''}`}>
                  <li>
                    <Link to="/photos-gallery">Photos Gallery</Link>
                  </li>
                  <li>
                    <Link to="/videos-gallery">Video Gallery</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/inspiration">Inspiration</Link>
              </li>
              <li>
                <Link to="/career">Career</Link>
              </li>
              <li>
                <Link to="/Trade">Trade</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="nav-col3" onClick={toggleSearchBar}>
            <div className="nav-search-bar">
              <FontAwesomeIcon icon={faSearch} />
            </div>
          </div>

          <div className="nav-col4">
            <div className="nav-call-btn" onClick={toggleModel}>
              REQUEST A CALL BACK
              <FontAwesomeIcon icon={faPhone} style={{ marginLeft: '8px' }} />
            </div>
          </div>
        </header>
      </div>

      <div className={`search-container ${searchBarIsOpen ? 'Open-search-container' : ''}`}>
        <input type="text" className="search-input" placeholder="Search..." />
        <button className="search-button">Search</button>
      </div>

      <div className={`modal-overlay ${ModelIsOpen ? 'opener' : ''}`}>
        <div className="callback-modal">
          <button className="modal-close-btn" onClick={toggleModel}>
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <div className="modal-title">
            <h5>Request a Call back</h5>
          </div>
          <div className="Model-Bottom">
            <form >
              <div className="modal-input">
                <PhoneInput
                  country={'in'}
                  enableSearch={true}
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                  placeholder="Your Number"
                  className="modal-input-feild"
                />
              </div>
              <div className="modal-buttons">
                <button type='submit' onClick={handleModalSubmit} className="model-submit-btn">
                  Submit
                </button>
              </div>
            </form>
            {showSuccess && (
              <div className="success-message" style={{ marginTop: '15px' }}>
                <FontAwesomeIcon icon={faCheckCircle} className="success-icon" />
                <p>Thank you! We'll call you back shortly.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;